
<template>
  <div class="login-container">
    <div v-if="false === IsCheckingLoign" class="login-content loading-container">
      <h1>
        ログイン
        <!-- <ruby>
          <rb>T字型思考</rb>
          <rt>ティーじがたしこう</rt>
        </ruby>を -->
         <!-- <img class="" src="../assets/images/txt-001-hajimeyou.svg"  >
        ！ -->
      </h1>

      <!-- ローディング -->
      <t-loading class="loading-item" :isLoading="IsLoading"></t-loading>

      <!-- メールアドレス -->
      <t-input
        v-model="ruleForm.email"
        v-validate="'required|email|max:254'"
        name="email"
        ref="email"
        :enterToEditEnd="false"
        v-bind:class="{disable:IsLoading}"
        :maxlength="254"
        class="input-container-cell"
        placeholder="メールアドレスをいれてね"
        inputType="text"
        label="・メールアドレス"
        iconClassName="fas fa-envelope"
        :isShowErrorMessage="errors.has('email')"
        :errorMessage="errors.first('email')"
        radius="30px"
      ></t-input>

      <!-- パスワード -->
      <t-input
        v-model="ruleForm.pass"
        v-validate="'required|max:20'"
        name="password"
        v-bind:class="{disable:IsLoading}"
        :enterToEditEnd="false"
        :maxlength="20"
        placeholder="パスワードをいれてね"
        inputType="password"
        label="・パスワード"
        iconClassName="fas fa-key"
        :isShowErrorMessage="errors.has('password')"
        :errorMessage="errors.first('password')"
        radius="30px"
      ></t-input>

      <!-- ログインボタン -->
      <button
        @click="SubmitForm()"
        v-bind:class="{disable:IsLoading || errors.has('email')|| errors.has('password')}"
        class="button-edit"
      >
        <i class="far fa-check-circle"></i>
        ログインする
        <div class="eigi">Login</div>
      </button>




     

      <!-- ヘルプコンテンツ -->
      <div class="help-content">


        

        <!-- <p>
          <router-link :to="{name:'login-phone'}">
            <span class="tag">
              <i class="fas fa-mobile-alt"></i>でんわ番号ログイン
            </span>
          </router-link>
        </p> -->

        <p>
          <router-link to="/request_reset_password">
            <span class="tag">
              <i class="fas fa-caret-right"></i>パスワードをお忘れですか？
            </span>
            <!-- <span class="text">こちらへどうぞ</span> -->
          </router-link>
        </p>

        <p>
          <router-link to="/signup">
            <span class="tag">
              <i class="fas fa-caret-right"></i>はじめての人： 無料でアカウント作成
            </span>
            <!-- <span class="text">
              無料でアカウント登録
            </span> -->
          </router-link>
        </p>

        <!-- <div @click="AnonymousLogin()">匿名でログイン</div> -->
      </div>

       <button class="button-later" @click="ShowLoginWithAnonymousDialog()">　
              <i class="fas fa-caret-right"></i>
             <span class="text">おためしで使ってみる（あとで登録）</span>
        </button>


    <!-- <div class="provide-login-content">
        <hr class="hr-text" data-content="Login With">
  　<div class="btn-provide-login color-phone" @click="LoginWithPhone()">
           <i class="fas fa-mobile-alt"></i>
          でんわ番号でログイン
    </div>

    <div class="btn-provide-login color-google" @click="LoginWithGoogle()">
            <i class="fab fa-google"></i>
          Googleでログイン
    </div>

     <div class="btn-provide-login color-facebook" @click="LoginWithFacebook()">
           <i class="fab fa-facebook"></i>
         Facebookでログイン
    </div>

    </div> -->




      <!-- ソーシャルアカウント -->
      <div class="sns-login-content">
        <hr class="hr-text" data-content="Login With">

        <div class="button-container">
          <div class="button-login btn-color-google" @click="LoginWithGoogle()">
            <i class="fab fa-google"></i>
            <div class="eigi">Login</div>
          </div>

          <div class="button-login btn-color-facebook" @click="LoginWithFacebook()">
            <i class="fab fa-facebook"></i>
            <div class="eigi">Login</div>
          </div>

          <!-- <div class="button-login btn-color-twitter" @click="LoginWithPhone()">
            <i class="fab fa-twitter"></i>
            <div class="eigi">Login</div>
          </div> -->


          <!-- <div class="button-login btn-color-phone" @click="LoginWithPhone()">
            でんわ
            <div class="eigi">Login</div>
          </div> -->

          <!-- <div class="button-login btn-color-yahoo" @click="LoginWithYahoo()">
            <i class="fab fa-yahoo"></i>
            <div class="eigi">Login</div>
          </div> -->
        </div>
      </div>


    </div>



        <!-- ===========================
      ツール：「名前入力」ダイアログ
      ===========================-->
 <t-dialog :show="showModal" >
   <!-- ::ヘッダー部分 -->
    <template slot="header" >
        <div class="dialog-title">
          おためしでつかう（あとで登録）<br/>

           <i class="far fa-arrow-alt-circle-down"></i>
     きみの
       <ruby>
          <rb>名前</rb>
          <rt>なまえ</rt>
        </ruby>を <ruby>
          <rb>入力</rb>
          <rt>にゅりょく</rt>
        </ruby>してはじめよう！
       </div>
</template>

<!-- ::ボディ部分 -->
  <template slot="body" >
     <div style="max-width:800px;" >
        <!-- 名前 -->
        <t-input
          v-model="ruleForm.yourName"
          v-validate="'required|max:20'"
          name="yourName"
          :enterToEditEnd="false"
          v-bind:class="{disable:IsLoading}"
          ref="yourName"
          :maxlength=25
          class="input-container-cell"
          placeholder="なまえをいれてね"
          inputType="text"
          label="・なまえ"
          iconClassName="fas fa-user"
          :isShowErrorMessage="errors.has('yourName')"
          :errorMessage="errors.first('yourName')"
          radius="30px"
        ></t-input>
        <!-- ログインボタン -->
        <button
          @click="StartLoginWithAnonymous()"
          v-bind:class="{disable:IsLoading || errors.has('yourName')}"
          class="button-edit"
        >
          <i class="far fa-check-circle"></i>
          はじめる
          <div class="eigi">Start</div>
        </button>
      </div>
  </template>
  <template slot="footer" >
      <div class="footer-container">
<div class="button-cancel" @click="CloseModal()">
    <i class="far fa-times-circle"></i>
        やめる
        </div>
      </div>
        
      </template>
 </t-dialog>





    
  </div>
</template>

<script>
//--------------------------------
//検証メッセージのカスタマイズ処理
//--------------------------------
import { Validator } from "vee-validate";
const dict = {
  custom: {
    email: {
      required: "メールアドレスをいれてね！",
      email: "ただしいメールアドレスをいれてね！",
      max: "※ 254文字以内でメールアドレスをいれてね"
    },
    password: {
      required: "パスワードをいれてね!",
      max: "パスワードは２０文字以内でいれてね!"
    },
    yourName: {
      required: "なまえをいれてね",
      max: "20文字以内でいれてね"
    }
  }
};
Validator.localize("ja", dict);

import TInput from "./TInput";
import Tloading from "./TLoading";
import TDialog from "./TDialog";
export default {
  name: "LoginHome",
  components: { TInput, TDialog, "t-loading": Tloading },
  data() {
    return {
      ruleForm: {
        email: "",
        pass: "",
        yourName: ""
      },

      IsLoading: false,
      IsCheckingLoign: false, //ユーザー確認中
      showModal: false
    };
  },
  props: {
    trial: Boolean
  },
  mounted() {
    this.IsCheckingLoign = true;

    var me = this;
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$router.push("/thinkpage");
        return;
      }
      this.IsCheckingLoign = false; //おためしでつかう

      if (this.trial) {
        this.$nextTick(() => {
          this.ShowLoginWithAnonymousDialog();
        });

        return;
      }

      //インプットにフォーカス
      //*非表示から表示後の処理なので、nextTickで、描画されるまで待つ必要あり。ないとinput参照できなかった。
      this.$nextTick(() => {
        this.$refs.email.ToFocus();
      });
    });
  },
  computed: {
    IsLogin() {
      if (null == this.$store.getters.loginUser) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ShowLoginWithAnonymousDialog() {
      this.showModal = true;
      this.$nextTick(() => {
        this.$refs.yourName.ToFocus();
      });
    },
    StartLoginWithAnonymous() {
      //値の検証
      this.$validator.validate("yourName").then(result => {
        //NG
        if (false === result) {
          return;
        }

        //OK
        //alert(this.ruleForm.yourName);
        this.LoginWithAnonymous();
      });
    },
    //================================
    //処理：でんわログイン
    //================================
    LoginWithPhone() {
      this.$router.push({ name: "login-phone" });
    },

    RegistYourNameProcess() {
      //todo:名前の登録
      this.showModal = false;
      var callback = function(result, msg) {
        if (result === false) {
          alert(msg);
        }
        this.IsLoading = false;
        this.ruleForm.yourName = ""; //リセット：なまえ
      }.bind(this);

      this.$store.dispatch("UpdateUserProfileName", {
        name: this.ruleForm.yourName,
        callback: callback
      });
    },
    //================================
    //処理：匿名ログイン
    //================================
    LoginWithAnonymous() {
      this.IsLoading = true;
      firebase
        .auth()
        .signInAnonymously()
        .then(
          function(result) {
            // The signed-in user info.
            //var user = result.user;

            //処理: 名前の登録
            this.RegistYourNameProcess();
            this.ShowMessageFOrAnonymousLogin();
          }.bind(this)
        )
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          alert(error);
          // ...
        });
    },
    ShowMessageFOrAnonymousLogin() {
      this.$message({
        dangerouslyUseHTMLString: true,
        message:
          '<strong>「きっずてぃーしんく」に興味をもっていただき、ありがとうございます！</strong><p style="margin-top:10px;margin-left:10px;">☆気に入っていただけたら、ぜひアカウント登録ください☆</p>',
        type: "success",
        showClose: true,
        duration: 25000
      });
    },
    //================================
    //処理：Yahooログイン
    //================================
    LoginWithYahoo() {
      var provider = new firebase.auth.OAuthProvider("yahoo.jp");
      // Request access to Yahoo Mail API.
      provider.addScope("mail-r");
      // Request read/write access to user contacts.
      // This must be preconfigured in the app's API permissions.
      provider.addScope("sdct-r");

      provider.setCustomParameters({
        // Prompt user to re-authenticate to Yahoo.
        prompt: "login",
        // Localize to japan.
        language: "ja"
      });

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          var user = result.user;
          alert(result);
          // User is signed in.
          // IdP data available in result.additionalUserInfo.profile.
          // Yahoo OAuth access token can be retrieved by calling:
          // result.credential.accessToken
          // Yahoo OAuth ID token can be retrieved by calling:
          // result.credential.idToken
        })
        .catch(function(error) {
          // Handle error.
          alert(error);
        });
    },
    //================================
    //処理：Facebookログイン
    //================================
    LoginWithFacebook() {
      var provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().languageCode = "ja"; //言語指定

      //ポップアップで表示
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          var token = result.credential.accessToken;
          var user = result.user;
          // ...
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
        });
    },
    //================================
    //処理：Twitterログイン
    //================================
    LoginWithTwitter() {
      //TODO..
    },
    //================================
    //処理：グーグルログイン
    //================================
    LoginWithGoogle() {
      //Google プロバイダ オブジェクトのインスタンスを作成します。
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().languageCode = "ja"; //言語指定

      //ポップアップで表示
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          var user = result.user;
          // ...
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
        });
    },
    SubmitForm() {
      //値の検証
      this.$validator.validateAll().then(result => {
        //NG
        if (false === result) {
          return;
        }

        //OK
        this.ExecLogin();
      });
    },
    //================================
    //処理：ログイン
    //================================
    ExecLogin() {
      this.IsLoading = true;
      var callback = function(result, msg) {
        if (false === result) {
          this.IsLoading = false;
          alert(msg);
          return;
        }
        this.IsLoading = false;
        this.ruleForm.email = "";
        this.ruleForm.pass = "";
      }.bind(this);

      this.$store.dispatch("Login", {
        email: this.ruleForm.email,
        password: this.ruleForm.pass,
        callback: callback,
        redirect: this.$route.query.redirect
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    NavigateTo(item) {
      //ページ遷移
      this.$router.push({ name: "WordsPage" });
    },
    //================================
    //閉じる：なまえ入力ダイアログ
    //================================
    CloseModal() {
      this.ruleForm.yourName = ""; //リセット：なまえ
      this.showModal = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./../assets/style/common.scss";

//---------------
// ボタンスタイル：リセット
//---------------
button {
  border: none;
  outline: none;
}

.help-content {
  margin-top: 30px;
  font-size: 14px;

  a {
    color: #42b983;
    text-decoration: none;

    & > .text {
      text-decoration: underline;
    }

    &:hover {
      opacity: 0.8;
      & > .text {
        text-decoration: none;
        color: coral;
      }
    }
  }

  .tag {
    & > i {
      margin-right: 5px;
    }
    background: #42b983;
    color: white;
    border-radius: 5px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: bold;
    margin-right: 5px;
  }
}

.sns-login-content {
  margin-top: 20px;
  margin-bottom: 10px;

  & > .button-container {
    text-align: center;
    margin: auto;
  }

  .hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
    opacity: 0.5;
  }
  .hr-text:before {
    content: "";
    background: -webkit-linear-gradient(
      left,
      transparent,
      #818078,
      transparent
    );
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  .hr-text:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;
    padding: 0 0.5em;
    line-height: 1.5em;
    color: #818078;
    background-color: #f6e8cc;
  }
}
//--------------
//ボタン:グーグルアカウントでログイン
//--------------
.btn-color-google {
  background: #dd4b39;
  border: 1px solid transparent;
  &:hover {
    background: #992617;
  }
}
.btn-color-facebook {
  background: #3b5998;
  border: 1px solid transparent;
  &:hover {
    background: #1a3266;
  }
}

.btn-color-yahoo {
  background: #410093;
  border: 1px solid transparent;
  &:hover {
    background: #2e0166;
  }
}

.btn-color-twitter {
  background: #55acee;
  border: 1px solid transparent;
  &:hover {
    background: #309bec;
  }
}

.btn-color-phone {
  background: #818081;
  &:hover {
    background: #535353;
  }
}

.btn-color-normal {
}

.button-login {
  cursor: pointer;
  color: #fff;
  display: inline-block;
  margin-right: 10px;

  text-align: center;
  border-radius: 35px;
  padding-top: 15px;
  padding-bottom: 0px;
  padding-left: 20px;
  padding-right: 18px;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  width: 60px;
  font-size: 16px;
  transition: all 200ms 0s ease;

  & > .eigi {
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 6px;
  }

  & > i {
    // display:block;
    margin-right: 6px;
    font-size: 20px;
    font-weight: normal;
  }
}

.loading-container {
  position: relative;
  .loading-item {
    position: absolute;
    bottom: 50%;
    left: 40px;
    z-index: 999;
    transform: scale(1);
  }
}

//---------------
// ユーザー確認中表示
//---------------
.checking-login {
  color: #42b983;
  font-weight: 600;
  font-size: 24px;
  margin-top: 100px;
  & > i {
    margin-right: 8px;
  }
}

//---------------
// :無効時のスタイル
//---------------
.disable {
  opacity: 0.3;
  cursor: default;
  pointer-events: none; // クリック、タッチを無効化
  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

//--------------
//ボタン:編集
//--------------
.button-edit {
  cursor: pointer;
  color: #fff;
  width: 100%;

  margin-top: 30px;
  display: block;
  //border: 1px solid #42b983;
  background: #42b983;
  text-align: center;
  border-radius: 28px;
  padding-top: 15px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 20px;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0px 3px #228659;

  transition: all 200ms 0s ease;

  & > .eigi {
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 4px;
  }

  &:hover {
    background: #228659;
    box-shadow: 0px 3px #186140;
  }

  & > i {
    margin-right: 5px;
    font-size: 16px;
    font-weight: normal;
  }
}

//--------------
//ボタン:あとで登録
//--------------
.button-later {
  cursor: pointer;
  color: #42b983;
  width: 100%;
  background: transparent;
  text-decoration: underline;
  margin-top: 20px;
  display: block;
  text-align: center;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  transition: all 200ms 0s ease;
  &:hover {
    text-decoration: none;
  }
}

.mt-10 {
  margin-top: 10px;
}
.login-container {
  display: flex;

  justify-content: center;
  align-items: center;
}

.login-content {
  //background:white;
  border-radius: 10px;
  padding: 40px;
  padding-top: 10px;
}

.el-form-item__content {
  border: 1px solid red;
}
.el-input {
  & > .el-input__inner {
    border: 1px solid red !important;
  }
}
.el-input__inner {
  border-radius: 90px !important;
}

h1 {
  /* //縁取り文字 */
  font-size: 20px;
  font-weight: 600;
  margin-top: 0px;
  text-align: center;
  // color: white;
  // -webkit-text-stroke-width: 1px;
  // -webkit-text-stroke-color: #666;
  // text-shadow: 1px 2px 0px #666;
  color: #228659;

  & > ruby > rt {
    color: #666;
    font-size: 12px;
    -webkit-text-stroke-width: 0px;
    text-shadow: none;
  }

  @include mq-down(sm) {
    font-size: 20px;
    color: #666;
    margin-bottom: 20px;
    -webkit-text-stroke-width: 0px;
    & > ruby > rt {
      font-size: 10px;
    }
  }
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.provide-login-content {
  margin-top: 20px;
  margin-bottom: 10px;
  .hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
    opacity: 0.5;
  }
  .hr-text:before {
    content: "";
    background: -webkit-linear-gradient(
      left,
      transparent,
      #818078,
      transparent
    );
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  .hr-text:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;
    padding: 0 0.5em;
    line-height: 1.5em;
    color: #818078;
    background-color: #f6e8cc;
  }
}

//=======================
//プロバイド：ログイン
//=======================
.btn-provide-login {
  cursor: pointer;

  & > i {
    //padding-right: 15px;
    width: 30px;
    font-size: 20px;
    border-right: 1px solid white;
    margin-right: 15px;
  }
  //background: #42b983;
  color: white;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 16px;
  font-weight: bold;
  height: 35px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-bottom: 15px;

  transition: all 200ms 0s ease;
}

//--------------
//ボタン:グーグルアカウントでログイン
//--------------
.color-google {
  background: #dd4b39;
  box-shadow: 0px 3px #ac2b1a;
  &:hover {
    background: #ac2b1a;
  }
}
.color-facebook {
  background: #3b5998;
  box-shadow: 0px 3px #283d6b;
  &:hover {
    background: #27488f;
  }
}

.color-phone {
  background: #818081;
  box-shadow: 0px 3px #474747;
  &:hover {
    background: #646464;
  }
}

//---------------
// ボタン：キャンセル
//---------------
.button-cancel {
  margin-top: 0px;
  display: inline-block;
  color: cadetblue;
  cursor: pointer;

  & > i {
    margin-right: 5px;
  }

  &:hover {
    color: coral;
  }
}

//---------------
// ダイアログ：タイトル
//---------------
.dialog-title {
  font-size: 18px;
  color: #42b983;

  & > i {
    margin-right: 5px;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginHome.vue